export const setRecaptchaScript = (siteKey) => {
  var recaptchScript = document.querySelector('#recaptchaScript');
  if (recaptchScript) {
    recaptchScript.setAttribute(
      'src',
      'https://www.google.com/recaptcha/api.js?render='+ siteKey
    );
  }
};
